import React, { PropTypes } from 'react';
import truncate from 'lodash/truncate';
import StarRating from 'common/components/star_rating';
import { getParticipantEmail } from 'focus_groups/utils';
import moment from 'moment';

const ResultVoteRow = ({ participant_email, participant_name, score, created_at }) => {
  const email = getParticipantEmail(participant_email);

  return (
    <tr>
      <td>
        { truncate(email, { length: 20 }) }
      </td>
      <td className="hide-for-small-only">
        { participant_name? truncate(participant_name, { length: 10 }) : '-' }
      </td>
      <td>
        <StarRating readonly={true} initialRate={score}/>
      </td>
      <td className="hide-for-small-only">{moment(created_at).fromNow()}</td>
    </tr>
  );
};

ResultVoteRow.propTypes = {
  participant_email: PropTypes.string.isRequired,
  participant_name: PropTypes.string,
  score: PropTypes.number.isRequired,
  created_at: PropTypes.string,
};

export default ResultVoteRow;



// WEBPACK FOOTER //
// ./focus_groups/components/result_vote_row.jsx